import TabletopItem from '../item/tabletopItem';
import AbstractValidator from './abstractValidator';
import ValidationResult from './validationResult';

/**
 * @class TabletopAreaValidator
 * @extends AbstractValidator
 */
export default class TabletopAreaValidator extends AbstractValidator {
    /**
     * @param {ProblemFactory} problemFactory
     * @param {string} message
     */
    constructor(problemFactory, message) {
        super(problemFactory);
        this.message = message;
    }

    /**
     * @param {AbstractItem} item
     * @return {ValidationResult[]}
     */
    validateItem(item) {
        if (this._isItemSupported(item)) return super.validateItem(item);
        if (item.hasParentItem()) return super.validateItem(item.getParentItem());

        return [new ValidationResult(this)];
    }

    _isItemSupported(item) {
        return item instanceof TabletopItem;
    }

    _isItemValid(item) {
        const maxCutArea = item.getArea() * 0.5;
        const cutArea = item.getItems()
            .filter(({ type }) => type !== 'tableleg')
            .reduce((total, subItem) => total + subItem.getArea(), 0);

        return cutArea < maxCutArea;
    }

    _createProblems(item) {
        return [this.problemFactory.createError('tabletopArea', this.message, 'warning-sign', [item])];
    }
}
